import React, { FC, useContext } from 'react';

import { Styled } from './index.styles';
import { ParkingProps } from '../../organisms/HotelInformation/HotelInformation.types';
import { serverData } from '../../organisms/HotelInformation/HotelInformation';
import { useCheckBreakpoint } from '../../hooks';
import clsx from 'clsx';
import { useHQVContext } from '../../context';
import { reorderCurrencyForRTL, getLocaleFromDocument } from '../../utils/index';
import { AR_LOCALE } from '../../modules/constants';

export const HotelParking: FC<{ hotelInformationData: { property: { parking: [] } } }> = ({ hotelInformationData }) => {
  const { jsonContent } = useContext(serverData);
  const parkingInfoList = hotelInformationData?.property?.parking;
  const isViewportL = useCheckBreakpoint('viewportL');
  const { hqvState } = useHQVContext();
  return (
    <Styled>
      <div className={clsx('parking', `${hqvState.modalOpenState ? 'hqv-modal' : ''}`)}>
        <div className={clsx('col', 'm-icon-text', 'section-heading')}>
          <span
            className={clsx(
              isViewportL ? 'icon-m' : 'icon-s',
              'icon-decorative',
              'icon-parking',
              'check-out',
              'left-col-icon',
              'parking-policy-icon'
            )}
          ></span>
          <span className={clsx(isViewportL ? 't-subtitle-l' : 't-subtitle-m', 'parking-heading')}>
            {jsonContent?.parkingLabel}
          </span>
        </div>
        <div className="parking-information">
          {parkingInfoList &&
            parkingInfoList.map((parkingInfo: ParkingProps, idx: number) => (
              <div key={'park' + idx}>
                <div className={clsx(isViewportL ? 't-font-s' : 't-font-xs', 'parking-item')} key={idx}>
                  {getLocaleFromDocument() === AR_LOCALE
                    ? reorderCurrencyForRTL(parkingInfo?.fees?.description ?? '')
                    : parkingInfo?.fees?.description}
                </div>
                <div className={clsx(isViewportL ? 't-font-s' : 't-font-xs', 'parking-item')}>
                  {getLocaleFromDocument() === AR_LOCALE
                    ? reorderCurrencyForRTL(parkingInfo?.description ?? '')
                    : parkingInfo?.description}
                </div>
              </div>
            ))}
        </div>
      </div>
      {/* )} */}
    </Styled>
  );
};

export default HotelParking;
